import React from 'react';

const TopRight1Shape = ({ className }) => {
  return (
    <svg
      className={className}
      width="548"
      height="204"
      viewBox="0 0 548 204"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M239.139 141.505C100.979 96.5377 0 38.7261 0 -84.914L209.61 -84.9141C335.269 -84.9141 445.909 -84.9141 478.788 -84.914C555.827 -84.9138 531.364 -12.1546 532.212 26.5147C535.927 71.7032 569.423 184.106 522.036 203.58C478.788 203.58 347.007 176.613 239.139 141.505Z" 
        fill="white"
      />
    </svg>

  );
};

export default TopRight1Shape;
